module.exports = __webpack_public_path__ + "img/frame (234).b3a31356.jpg";